import networkOffline from './saveFailedRequest.middleware';

export default networkOffline;
